const resultsHappiness = {
  "payload": [
    {
      "name": "Alegría",
      "count": 40
    },
    {
      "name": "Amor",
      "count": 50
    },
    {
      "name": "Culpa",
      "count": 0
    },
    {
      "name": "Desagrado",
      "count": 1
    },
    {
      "name": "Furia",
      "count": 0
    },
    {
      "name": "Gratitud",
      "count": 68
    },
    {
      "name": "Ira",
      "count": 0
    },
    {
      "name": "Odio",
      "count": 0
    },
    {
      "name": "Temor",
      "count": 3
    },
    {
      "name": "Tristeza",
      "count": 2
    }
  ]
};

const responseWeeklyChart = {
  payload: 
  {
    "windows": {
      "W1": {
        "labels": ["Lunes","Martes","Miércoles","Jueves","Viernes"],
        "datasets": [
          {"label":"Alegría","data":[25,15,18,12,22]},
          {"label":"Tristeza","data":[5,0,8,10,6]},
          {"label":"Neutral","data":[12,13,7,9,19]}
        ]
      },
      "W2": {
        "labels": ["Lunes","Martes","Miércoles","Jueves","Viernes"],
        "datasets": [
          {"label":"Alegría","data":[45,20,40,28,57]},
          {"label":"Tristeza","data":[7,1,9,15,8]},
          {"label":"Neutral","data":[10,21,17,30,22]}
        ]
      }
    }
  }
};

const responseMonthlyChart = {
  payload: 
  {
    "windows": {
      "W1": {
        "labels": ["Semana 1","Semana 2","Semana 3","Semana 4","Semana 5"],
        "datasets": [
          {"label":"Alegría","data":[45,15,18,12,22]},
          {"label":"Tristeza","data":[2,0,8,10,6]},
          {"label":"Neutral","data":[22,13,7,9,19]}
        ]
      },
      "W2": {
        "labels": ["Semana 1","Semana 2","Semana 3","Semana 4","Semana 5"],
        "datasets": [
          {"label":"Alegría","data":[55,20,40,28,57]},
          {"label":"Tristeza","data":[7,1,9,15,8]},
          {"label":"Neutral","data":[10,21,17,30,22]}
        ]
      }
    }
  }
};

const responseAnnualChart = {
  payload: 
  {
    "windows": {
      "W1": {
        "labels": ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],
        "datasets": [
          {"label":"Alegría","data":[35,15,18,12,22,55,35,65,27,60,53,11]},
          {"label":"Tristeza","data":[3,0,8,10,6,45,25,15,38,10,33,6]},
          {"label":"Neutral","data":[52,13,7,9,19,25,15,18,12,22,55,35]}
        ]
      },
      "W2": {
        "labels": ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],
        "datasets": [
          {"label":"Alegría","data":[45,20,40,28,57,25,15,18,12,22,55,35]},
          {"label":"Tristeza","data":[7,1,9,15,8,2,4,7,10,11,2,30]},
          {"label":"Neutral","data":[10,21,17,30,22,25,15,18,12,22,55,35]}
        ]
      }
    }
  }
};

export const service = {
  getResultsHappiness: () => new Promise(resolve => {
    setTimeout(resolve({ data: resultsHappiness }), 1000);
  }),

  getResultsWeeklyChart: () => new Promise(resolve => {
    setTimeout(resolve({ data: responseWeeklyChart }), 1000);
  }),

  getResultsMonthlyChart: () => new Promise(resolve => {
    setTimeout(resolve({ data: responseMonthlyChart }), 1000);
  }),

  getResultsAnnualChart: () => new Promise(resolve => {
    setTimeout(resolve({ data: responseAnnualChart }), 1000);
  }),
}